import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/ComingSoon';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const TacticalDronesPage = () => {
  return <ComingSoon title="Tactical Drones" subtitle="Our Products" />;
};

export const Route = createFileRoute('/products/tactical-drones')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: TacticalDronesPage,
});

